<template>
  <div>
    <div
      class="min-h-screen flex flex-col items-center justify-center sm:px-4"
      :style="{ fontFamily: global.fontFamily }"
      :class="{
        'pointer-events-none': isLoading,
        'opacity-50': isLoading
      }"
    >
      <router-view v-if="configIsSet" />
    </div>
    <Loading v-if="isLoading" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Loading from '@/components/atoms/Loading.vue';
import { getClientConfig, setClientFavicon } from '@/service/clientService';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'App',
  components: {
    Loading
  },
  async mounted () {
    this.startLoading();
    await getClientConfig();
    setClientFavicon();
    this.endLoading();
  },
  methods: {
    ...mapActions(['startLoading', 'endLoading'])
  },
  computed: {
    ...mapGetters([
      'global',
      'isLoading',
      'configIsSet'
    ])
  }
});
</script>

<style>
html, body {
  max-width: 100%;
}

body {
  overflow-x: hidden;
  scroll-behavior: smooth;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}
</style>
